export default __webpack_public_path__ + "static/media/fasle-bahar.7ac03377.mp3";